import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PickUpCenter, UserAddress, User } from 'src/app/_models';
import { UtilsService, UserService } from 'src/app/_services';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ZipCodeValidator } from 'src/app/_validators/zipcode.validator';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/_guards/can-deactivate/component-can-deactivate';
import { BasketService } from 'src/app/_services/basket.service';
import { tap } from 'rxjs/operators';



declare const $ : any ;

@Component({
  selector: 'app-user-address',
  templateUrl: './user-address.component.html',
  styleUrls: ['./user-address.component.css']
})

export class UserAddressComponent extends ComponentCanDeactivate  implements OnInit {

  @Input() address : UserAddress;
  @Input() index : number;
  @Input() canCheckPrincipal : boolean;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();

  public addressEditForm : FormGroup;
  public pickUpCenters : PickUpCenter[];
  public pickUpCenter : boolean;
  

  public pickupCenterName : Observable<string>;
  private pickupCenterNameSubject : BehaviorSubject<string>;
  public showPickupcCenterName: boolean;
  private isPlannedAddress : boolean;

  constructor(
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private zipCodeValidator: ZipCodeValidator,
    private toastr: ToastrService,
    public translate : TranslateService,
    private users: UserService,
    private basket: BasketService
  ) {
    super();
    
    this.pickupCenterNameSubject = new BehaviorSubject<string>('');
    this.pickupCenterName = this.pickupCenterNameSubject.asObservable();
  }

   get f() { 
    return this.addressEditForm.controls; 
  }

  ngOnInit() {

    this.addressEditForm = this.formBuilder.group({
      name: [this.address.address_name,  Validators.required],
      street: [this.address.address_street,  Validators.required],
      number: [this.address.address_number,  Validators.required],
      floor: [this.address.address_floor],
      door: [this.address.address_door],
      stair: [this.address.address_stair],
      zipCode: [this.address.zipcode,  Validators.required, this.zipCodeValidator.checkZipCode.bind(this.zipCodeValidator ) ],
      city: [this.address.city,  Validators.required],
      province: [this.address.province,  Validators.required],
      addressType: [this.address.isprimary],
      observ: [this.address.observ],
      recid: [this.address.recid],
    });
  
    if (!this. canCheckPrincipal){
      this.addressEditForm.controls.addressType.disable();
    }
   
    this.utils.getPickUpCenter(this.f.zipCode.value).subscribe( 
      pickUpCenter => { 
        if (parseInt(pickUpCenter) == 0){
          this.showPickupcCenterName = true;
        } else{
          this.showPickupcCenterName = false;
        }
      },
      error => {
        this.showPickupcCenterName = true;
      } 
    );

    this.pickupCenterNameSubject.next(this.utils.getPickUpCenterName(this.address.centre_ClickRecull) );   


    this.basket.delivery.subscribe( delivery => {    
      this.isPlannedAddress = delivery && delivery.id_tipo == this.address.recid;
    }); 
    
  }

  canDeactivate() : boolean{
    return ! this.addressEditForm.dirty;
  }

  setZipCode (){
    
    this.utils.getProvince(this.f.zipCode.value).subscribe(province => this.f.province.setValue(province));
    this.utils.getPickUpCenter(this.f.zipCode.value).subscribe( 
      pickUpCenter => { 
        if (parseInt(pickUpCenter) == 0){
          this.pickUpCenter = true;
          this.showPickupcCenterName = false;
          this.addressEditForm.addControl('pickUpCenter', new FormControl( '', Validators.required));
          this.utils.getPickUpCenters().subscribe(pickupCenters => this.pickUpCenters = pickupCenters);
          this.pickupCenterNameSubject.next('');
        } else{
          this.pickUpCenter = false;
          this.showPickupcCenterName = false;
          this.addressEditForm.removeControl('pickUpCenter');
          this.pickupCenterNameSubject.next(this.utils.getPickUpCenterName(pickUpCenter));      
        }
      },
      error => {
        this.pickUpCenter = true;
        this.showPickupcCenterName = false;
        this.addressEditForm.addControl('pickUpCenter', new FormControl( '', Validators.required));
        this.utils.getPickUpCenters().subscribe(pickupCenters => this.pickUpCenters = pickupCenters);
        this.pickupCenterNameSubject.next('');
      } 
    );

  }

  onSubmit(){

    if (this.addressEditForm.invalid){
      return;
    }

    this.address.address_name = this.f.name.value;
    this.address.address_street = this.f.street.value;
    this.address.address_door = this.f.door.value;
    this.address.address_floor= this.f.floor.value;
    this.address.address_number= this.f.number.value;
    this.address.address_stair =  this.f.stair.value;
    this.address.address_type = 2
    this.address.city = this.f.city.value;
    this.address.province = this.f.province.value;
    this.address.observ = this.f.observ.value;
    this.address.recid = this.f.recid.value;
    
    if (this.f.addressType.value) {
      this.address.isprimary = 1;
    }
    else {
      this.address.isprimary = 0;
    }

    this.address.zipcode = this.f.zipCode.value ;
    
    if (this.pickUpCenter) {
      this.address.centre_ClickRecull = this.f.pickUpCenter.value ;
    } else if (! this.showPickupcCenterName) {
      this.address.centre_ClickRecull = '';
    }
    
    


    if ( this.isPlannedAddress ) {
      $('#modal-confirm-save_' + this.address.recid).modal('show');
    } else {
      this.users.updateAddress(this.address).subscribe( result => {
        this.addressEditForm.markAsPristine();
        this.notifyParent.emit();
      }); 
    }

  }

  onConfirmSave(id: string){
    this.users.updateAddress(this.address).subscribe( result => {
      this.addressEditForm.markAsPristine();
      this.notifyParent.emit();
    }); 
  }


  onConfirmDelete(id: string){
    this.users.editingUser.subscribe( user =>{
      const address =  user.user_addresses.find(a => 'del_' + a.recid == id);
      if (address) {
        this.users.deleteAddress(address).subscribe(result =>{
          this.notifyParent.emit();
        });
      }
    });
  }

  onChangePickupCenter (){

    this.pickupCenterNameSubject.next(this.utils.getPickUpCenterName(this.f.pickUpCenter.value));
                                                                            
  }



}
